import addtocart from './add-to-cart';
import audio from './audio';
import background from './background';
import button from './button';
import ecommercecart from './e-commerce-cart';
import facebook from './facebook';
import form from './form';
import picture from './picture';
import gmaps from './gmaps';
import hotspot from './hotspot';
import iframe from './iframe';
import shape from './shape';
import slideshow from './slideshow';
import text from './text';
import twitter from './twitter';
import video from './video';
import rmheader from './rm-header';
import rmfooter from './rm-footer';
import rmcookies from './rm-cookies';

export default {
  addtocart,
  audio,
  background,
  button,
  ecommercecart,
  facebook,
  form,
  picture,
  gmaps,
  hotspot,
  iframe,
  shape,
  slideshow,
  text,
  twitter,
  video,
  rmheader,
  rmfooter,
  rmcookies,
};
